import { HStack, VStack, IconButton } from '@cad-arc';
import { useWatch } from 'react-hook-form';
import { SubjectStopForm, SubjectStopOptions } from '@mark43/cad-api';
import { FormCheckbox } from '../forms/integrated-form-controls/form-checkbox';
import { FormNumberInput } from '../forms/integrated-form-controls/form-number-input';
import { FormSelect } from '../forms/integrated-form-controls/form-select';
import { SectionTitle } from '../fr-event-common-components/section-title';
import { FrEventSubjectDataCheckboxesMultiselectField } from './fr-event-subject-data-checkboxes-multiselect-field';
import { useIntegratedForm } from '../forms/use-integrated-form';

export function FrEventSubjectsSection({
    subject,
    index,
    subjectStopOptions,
    removeSubject,
}: {
    subject: SubjectStopForm['subjectDataForms'][0];
    index: number;
    subjectStopOptions: SubjectStopOptions;
    removeSubject: () => void;
}) {
    const { form, isSubmitting } = useIntegratedForm<SubjectStopForm>();
    const subjects = useWatch({ control: form.control, name: 'subjectDataForms' });

    return (
        <VStack marginTop={8} key={subject.id} width="100%" alignItems="flex-start" gap={1}>
            <HStack width="100%" alignItems="center" justifyContent="space-between">
                <SectionTitle title={`Subject ${index + 1}`} />
                <IconButton
                    isDisabled={isSubmitting}
                    variant="ghost"
                    icon="TrashCan"
                    onClick={removeSubject}
                />
            </HStack>
            <FormSelect
                control={form.control}
                label="Reason For Stop"
                name={`subjectDataForms.${index}.reasonForStopOption`}
                options={subjectStopOptions?.reasonForStopOptions ?? []}
                showRequiredIndicator
                isDisabled={isSubmitting}
            />
            <FormNumberInput
                control={form.control}
                name={`subjectDataForms.${index}.perceivedAge`}
                label="Perceived age"
                showRequiredIndicator
                isDisabled={isSubmitting}
                numberInputProps={{ precision: 0 }}
            />
            <FormCheckbox
                name={`subjectDataForms.${index}.isPerceivedLgbt`}
                label="Perceived to be LGBT"
                control={form.control}
                isDisabled={isSubmitting}
            />
            <FormCheckbox
                name={`subjectDataForms.${index}.isEnglishFluent`}
                label="Limited or no English fluency"
                control={form.control}
                isDisabled={isSubmitting}
            />
            <FrEventSubjectDataCheckboxesMultiselectField
                title="Perceived Race"
                name="perceivedRaceOptions"
                options={subjectStopOptions.perceivedRaceOptions}
                index={index}
                selectedOptions={subjects[index]?.perceivedRaceOptions ?? []}
            />
            <FrEventSubjectDataCheckboxesMultiselectField
                title="Perceived Gender"
                name="genderOptions"
                options={subjectStopOptions.genderOptions}
                index={index}
                selectedOptions={subjects[index]?.genderOptions ?? []}
            />
            <FrEventSubjectDataCheckboxesMultiselectField
                title="Perceived or Known Disability"
                name="perceivedOrKnownDisabilityOptions"
                options={subjectStopOptions.perceivedOrKnownDisabilityOptions}
                index={index}
                selectedOptions={subjects[index]?.perceivedOrKnownDisabilityOptions ?? []}
            />
            <FrEventSubjectDataCheckboxesMultiselectField
                title="Result Of Stop"
                name="resultOfStopOptions"
                options={subjectStopOptions.resultOfStopOptions}
                index={index}
                selectedOptions={subjects[index]?.resultOfStopOptions ?? []}
            />
        </VStack>
    );
}
